import { Global, css } from '@emotion/react';

export const GlobalStyles = () => {
  return (
    <Global
      styles={css`
        * {
          line-height: 1.5;
        }

        body {
          font-family: Inter;
          font-size: 14px;
          // Fix scrollbars throughout the app
          scrollbar-color: rgba(105, 112, 125, 0.5) rgba(0, 0, 0, 0);
          scrollbar-width: thin;
        }

        a,
        a > div {
          color: black;
          :hover {
            color: black;
            text-decoration: underline;
          }
        }

        li {
          line-height: 20px;
        }

        .euiFormControlLayoutCustomIcon svg,
        svg,
        svg.euiIcon(not: .euiFlyout  {
          fill: none;
        }

        svg.strokeCurrentColor,
        .strokeCurrentColor svg {
          stroke: currentColor;
          fill: none;
        }

        .no-stroke svg,
        svg.no-stroke,
        svg.no-stroke.euiIcon,
        svg.euiIcon .no-stroke {
          stroke: none !important;
          fill: currentColor;
        }
      `}
    />
  );
};

export default GlobalStyles;
